export default "__VITE_ASSET__CEQBpwA$__"